import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';
import { addressCharacters } from '@parchment/validation-utils';
import ComposedTextField from '../ComposedField/ComposedTextField';
import ComposedSelectField from '../ComposedField/ComposedSelectField';
export default function State(_ref) {
  let {
    name = 'state',
    label = 'State/Province',
    autoComplete = 'address-level1',
    validators = [{
      message: 'Please enter a valid State/Province',
      callback: addressCharacters
    }],
    visited: visitedProp = false,
    options = [],
    onChange,
    ...props
  } = _ref;
  const [visited, setVisited] = useState(visitedProp);
  const [value, setValue] = useState(props.value || undefined);
  useEffect(() => setValue(props.value), [props.value]);
  useEffect(() => onChange && onChange(value), [value]);
  const commonProps = {
    ...props,
    name,
    label,
    autoComplete,
    validators,
    visited,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onBlur: e => {
      setVisited(true);
      props.onBlur && props.onBlur(e);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, options.length > 1 ? /*#__PURE__*/React.createElement(ComposedSelectField, _extends({}, commonProps, {
    onFocus: () => undefined,
    required: true,
    options: options,
    value: value || '',
    onChange: val => setValue(val)
  })) : /*#__PURE__*/React.createElement(ComposedTextField, _extends({}, commonProps, {
    required: false,
    value: value || '',
    onChange: val => setValue(val)
  })));
}